import { render, staticRenderFns } from "./Subcontractor.vue?vue&type=template&id=212b0bd6&scoped=true"
import script from "./Subcontractor.vue?vue&type=script&lang=js"
export * from "./Subcontractor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212b0bd6",
  null
  
)

export default component.exports